import React from 'react';
import './Petbottlehandel.css';
import petbottlehand from '../../../imgs/petbottlehandle.webp';

const Petbottlehandel = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">PET BOTTLE HANDLE</h2>

                <p className="Ordinary-text">The plastic ring pull handle is designed for single bottles,
                     making the bottle easy to grip, carry and pour.
                     The plastic eye ring provides a snug fit on the neck portion of the bottle and can be installed without heat to allow it to be stretched.</p>
                <p className="Ordinary-text">When we lift and carry the bottle,
                     the bottle does not slip out of the snap ring. The tight,
                     strong clip will lock tightly onto the neck of 
                     the neck and stay there until you snap the snap.</p>
                     <p className="Ordinary-text">Plastic bottle handles are generally made of PE,
                         HDPE and PP materials by injection molding machines.</p>
                <div className="Ordinary">
                    <img src={petbottlehand} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Ordinary-text">Disha KII288-S7 high-precision injection molding machine with high molding stability. 
                    The optimized injection mechanism reduces the injection resistance and
                     improves the speed and accuracy of the product.</p>
              
            </div>

        </div>
    );
};

export default Petbottlehandel;
